import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { AuthenticationService, HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext, foundationContext } from '@philips-internal/oswald-ui-foundation';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import BaseController from '../BaseController';

@Controller({ fragment: 'app', component: 'layout-app' })
class RootController extends BaseController {

  @OnMount({ target: ['layout-app'] })
  onMountLayout(): void {
    applicationContext.openModule('exam-results', { preventNavigation: true });
    applicationContext.openModule('users', { preventNavigation: true });
  }

  @OnMount({ target: ['route-login'] })
  async onMount(): Promise<void> {
    if (await this.assignTerms()) {
      this.doNavigation();
    } else {
      AuthenticationService.logout();
    }
  }

  async assignTerms(): Promise<boolean> {
    const currentRoute = this.historyService.getCurrentRoute();
    const result = await HttpService.get(APPLICATION_ENDPOINTS.CHECK_ASSIGN_TERMS);
    if (!result.body && (!currentRoute.startsWith('/terms-of-use') && !currentRoute.startsWith('/privacy'))) {
      return false;
    }
    return true;
  }

  doNavigation(): void {
    if (!AuthenticationService.isAuthenticated()) {
      return;
    }
    const currentRoute = this.historyService.getCurrentRoute();
    const module = foundationContext.getModule('9125');
    const param = module?.parameters.get('5')?.toString() != null ? module?.parameters.get('5')?.toString() : 'N';

    if (currentRoute === APPLICATION_ROUTES.LOGIN || currentRoute === '/' || currentRoute === '/results'
      || (param === 'N' && currentRoute.includes(APPLICATION_ROUTES.USERS))) {
      this.historyService.push(APPLICATION_ROUTES.EXAMS_RESULTS, { personId: sessionStorage.getItem('MainUser.USER_CODE') || 0 });
    }
  }
}

export default RootController;
